module.exports = __webpack_public_path__ + "img/bingo_ball-24.a44543bd.png";